import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';

export const fetchChallengeGroupRequest = createAction('fetchChallengeGroupRequest');
export const fetchChallengeGroupSuccess = createAction<ChallengeGroup>(
    'fetchChallengeGroupSuccess',
);
export const fetchChallengeGroupFailure = createAction('fetchChallengeGroupFailure');

export const fetchChallengeGroup = (id: number) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchChallengeGroupRequest());
    try {
        const { data } = await api.get<ChallengeGroup>('admin/challengeGroups/' + id);

        dispatch(fetchChallengeGroupSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengeGroupFailure, e);
    }
};
